import {
    TypedUseSelectorHook,
    useDispatch,
    useSelector,
    useStore,
} from 'react-redux'
import { AppDispatch, RootState } from './store'

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

/**
 * Access the store without subscribing to it. Use when a value is needed
 * imperatively (e.g. reading a saved scroll offset once on mount) and
 * subscribing via useAppSelector would cause needless re-renders.
 */
export const useAppStore = (): ReturnType<typeof useStore<RootState>> =>
    useStore<RootState>()
